module.exports = __webpack_public_path__ + "img/new_health.36ef9f17.svg";